// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vw_a bhi_b bhi_wb"};